import React from "react";
import { Link } from "react-router-dom";
import LoginButton from "../components/LoginButtons";

export default function SubscribePage({ user }) {
  const handleSubscribe = async () => {
    if (!user) {
      alert("灯主になるにはログインが必要です。\n棚に灯りを置くには、まず灯主としての灯をともしてください。");
      return;
    }

    try {
      const res = await fetch("https://us-central1-kotobano-yurusikata.cloudfunctions.net/api/generate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          uid: user.uid,
          email: user.email
        })
      });

      if (!res.ok) {
        throw new Error(`サーバーエラー: ${res.status}`);
      }

      const data = await res.json();

      if (!data.url) {
        throw new Error("StripeセッションURLが取得できませんでした");
      }

      window.location.href = data.url;
    } catch (error) {
      console.error("取得に失敗しました:", error);
      alert("灯主になる処理に失敗しました。もう一度お試しください。");
    }
  };

  return (
    <div style={styles.wrapper}>
      <h2 style={styles.title}>ゆるしの灯プラン</h2>

      <p style={styles.description}>
        灯主になることで、ことばの灯りを絶やさずともすことができます。<br />
        あなたの感情に灯をともし、空気設計の世界観に参加しませんか？
      </p>

      <ul style={styles.benefits}>
        <li>🕯️ 無料供養の回数制限が解除されます</li>
        <li>📚 灯りの置き場に無制限にことばを並べられます</li>
        <li>🌌 灯主専用の語り口に触れられます</li>
        <li>🌿 空気を読むだけでなく、空気を灯す存在になれます</li>
      </ul>

      {/* ✅ ログイン済みなら購読ボタンを表示 */}
      {user ? (
        <>
          <button onClick={handleSubscribe} style={styles.subscribeBtn}>
            灯主になる（月額プランに申し込む）
          </button>
          <p style={styles.note}>
            ※ Stripeによる安全な決済ページに遷移します
          </p>
        </>
      ) : (
        <>
          <p style={{ fontSize: "0.9em", color: "#666", marginBottom: "12px" }}>
            灯主になるにはログインが必要です
          </p>
          <LoginButton onLogin={() => window.location.reload()} />
        </>
      )}

      <div style={{ marginTop: "40px" }}>
        <Link
          to="/"
          style={{
            fontSize: "0.9em",
            textDecoration: "underline",
            color: "#888"
          }}
        >
          変換ページに戻る
        </Link>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    padding: "40px 20px",
    maxWidth: "600px",
    margin: "0 auto",
    textAlign: "center",
    backgroundColor: "#fffefc",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
  },
  title: {
    fontSize: "24px",
    marginBottom: "20px",
    color: "#333"
  },
  description: {
    fontSize: "16px",
    marginBottom: "20px",
    lineHeight: "1.6",
    color: "#444"
  },
  benefits: {
    listStyle: "none",
    padding: 0,
    marginBottom: "30px",
    fontSize: "15px",
    color: "#333",
    lineHeight: "1.8"
  },
  subscribeBtn: {
    padding: "12px 24px",
    backgroundColor: "#ff6666",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "16px",
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
  },
  note: {
    fontSize: "0.8em",
    color: "#888",
    marginTop: "20px"
  }
};
